import currencyFormatter from 'currency-formatter';

export function toBRL(value: number) {
  return currencyFormatter.format(value, { code: 'BRL' });
}

export function toCard(value: string) {
  const card = value.replace(/\*/g, 'X');
  const part1 = `${card[0]}${card[1]}${card[2]}${card[3]}`;
  const part2 = `${card[4]}${card[5]}${card[6]}${card[7]}`;
  const part3 = `${card[8]}${card[9]}${card[10]}${card[11]}`;
  const part4 = `${card[12]}${card[13]}${card[14]}${card[15]}`;

  return `${part1} ${part2} ${part3} ${part4}`;
}
